<div class="copyright-wrapper">
  <span class="copyright">Copyright &copy;<span>{{currentYear}}</span> Quantuvis Inc. All rights reserved.</span>
</div>
